// extracted by mini-css-extract-plugin
export default {"card":"styles_card__XWn+t","title":"styles_title__ybwGA","addVariantBtn":"styles_addVariantBtn__fieoC","plusIcon":"styles_plusIcon__T2eAz"};